import styled from 'styled-components/native';
import { themes } from '../../design/colors';
import { Feather as IconsFE, FontAwesome5 as IconsFA5 } from '@expo/vector-icons';

export const TextButtonLogout = styled.Text`
  color: ${themes.colors.red1};
  flex: 1;
  text-align: center;
  top: 15px;
  font-weight: bold;
  font-size: 16px;
`;

export const ContentEditProfile = styled.TouchableOpacity``;

export const TextEditProfile = styled.Text`
  color: ${themes.colors.primary};
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  margin-top: 10px;
`;

export const ButtonLogout = styled.TouchableOpacity`
  flex-direction: row;
  justify-content: space-between;
  margin-top: 30px;
  height: 50px;
  border-radius: 5px;
`;

export const IconFE = styled(IconsFE)``;

export const DataUser = styled.Text`
  font-size: 22px;
  color: ${themes.colors.gray3};
  font-weight: bold;
  text-transform: capitalize;
`;


export const TitleDataUser = styled.Text`
  font-size: 12px;
  color: ${themes.colors.gray4};
`;


export const ContentAvatar = styled.View`
  align-items: center;
`;